import { inject } from '@angular/core'
import { ActivatedRouteSnapshot, MaybeAsync, Router, RouterStateSnapshot } from '@angular/router'
import { PublicViewAuthService } from '../services/public-view-auth.service'

export const publicViewAuthGuard = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(PublicViewAuthService);
  const router = inject(Router);
  let accessGranted: MaybeAsync<boolean> = false;
  
  if (route.routeConfig?.path === 'dashboard/public/:uuid') {
    const uuid = route.params['uuid'] as string;
    accessGranted = authService.accessGranted(uuid);
    accessGranted.then((success: boolean) => {
      if (!success) {
        router.navigate(['']);
      }
    });
  }

  return accessGranted
}
